// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"W2-z"};